{
  const apiPath = "https://api-b7f90015.moot.tech/mv/api/2023-01";

  function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function getAnalyticsData() {
    const analytics = window?.ShopifyAnalytics;
    const attributes = analytics?.lib?.trekkie?.defaultAttributes;
    const page = window?.meta?.page;

    return { attributes, page };
  }

  const populateTagName = (collectionId, recentlyViewedTags) => {
    if (!recentlyViewedTags) {
      return "";
    }

    // set some disallowed tags which could confuse things (mens with female, etc. or generic / season related) -- we can set these manually if needed
    const disallowedTagNames = [
      "discontinued",
      "gift-ideas",
      "mens",
      "male",
      "female",
      "womens",
      "kids",
      "accessories",
      "sale",
      "top-seller",
      "trending",
      "new-arrivals",
      "all",
      "all-products",
      "all-products",
      "mothersday",
      "fathersday",
      "plussizes",
      "halloween",
      "alloverprint",
      "fashion",
      "metalfashion",
      "unisex",
      "gothichorror",
      "adorablelable",
      "xl",
      "valentine",
    ];

    // create a new array of recently viewed tags that don't include any of the disallowed tags
    let filteredRecentlyViewedTags = recentlyViewedTags.filter((viewedTag) => {
      return !disallowedTagNames.some((disallowedTag) =>
        viewedTag.tag.includes(disallowedTag)
      );
    });

    // remove any tag names that include the word/chars 'label'
    filteredRecentlyViewedTags = filteredRecentlyViewedTags.filter(
      (viewedTag) => !viewedTag.tag.includes("label")
    );
    const countWeight = 0.333;
    const timeWeight = 20;

    let weightedTags = [...filteredRecentlyViewedTags];

    // Normalize the timestamp to a range between 0 and 1
    weightedTags.forEach((tag) => {
      const normalizedTime =
        (tag.time - Math.min(...weightedTags.map((t) => t.time))) /
        (Math.max(...weightedTags.map((t) => t.time)) -
          Math.min(...weightedTags.map((t) => t.time)));
      tag.score = countWeight * tag.count + timeWeight * normalizedTime;
    });

    weightedTags.sort((a, b) => b.score - a.score);

    const setTagName = (tagList, defaultTag) => {
      return tagList && tagList.length > 0 ? tagList[0].tag : defaultTag;
    };

    let tagName = "";
    let tweakedRecentlyViewedTags = [];

    // not all of these work across all collections, so we'll need to tweak them -- remove a few words where we're not returning great results
    const undesirableMensTags = ["cute", "adorable", "roses"]; // remove certain tags from mens, like cute or adorable
    const undesirableWomensTags = ["gaming"]; // usally just lack of tagged products
    switch (collectionId) {
      case "mens":
        tweakedRecentlyViewedTags = weightedTags.filter(
          (viewedTag) => !undesirableMensTags.includes(viewedTag.tag)
        );
        tagName = setTagName(tweakedRecentlyViewedTags, "male");
        break;
      case "womens":
        tweakedRecentlyViewedTags = weightedTags.filter(
          (viewedTag) => !undesirableWomensTags.includes(viewedTag.tag)
        );
        tagName = setTagName(tweakedRecentlyViewedTags, "female");
        break;
      case "kids":
        tagName = setTagName(weightedTags, "kids");
        break;
      case "accessories":
        tagName = setTagName(weightedTags, "accessories");
        break;
      case "sale":
        tagName = setTagName(weightedTags, "sale");
        break;
      default:
        tagName = setTagName(weightedTags, "top-seller");
        break;
    }

    return tagName;
  };
  (async () => {
    const endpointUrl = `${apiPath}/sprl_us/quantlet`;
    const collectionPath = `${endpointUrl}/calc_trending_trans_lst_prd?`;
    const collectionTagPath = `${endpointUrl}/calc_trending_trans_lst_lab_prd?`;
    const recentlyViewedTags = JSON.parse(
      localStorage.getItem("recentlyViewedTags")
    );

    const currentUrl = window.location.href.split("/collections/")[1];
    let collectionId = currentUrl.split("/")[0];
    let tagName = currentUrl.split("/")[1];

    if (tagName && tagName.includes("?")) {
      // remove query params from collection name
      tagName = tagName.split("?")[0];
    }

    if (!tagName) {
      if (collectionId === "all") {
        // all category is a bit weird, so we'll just use trending
        collectionId = "trending";
        tagName = "top-seller";
      } else {
        tagName = populateTagName(collectionId, recentlyViewedTags);
      }
    }

    if (collectionId) {
      const { attributes, page } = getAnalyticsData();
      const cart_token = getCookie("cart");
      const session_key = attributes?.visitToken
        ? attributes.visitToken.replace(/-/g, "").toLowerCase()
        : undefined;
      const visitor_key = attributes?.uniqToken
        ? attributes.uniqToken.replace(/-/g, "").toLowerCase()
        : undefined;
      const customer_key = page?.customerId
        ? page.customerId.toString()
        : undefined;

      let session_data_qs = "";

      // build up query string data
      session_data_qs += `&cart_token=${cart_token ? cart_token : ""}`;
      session_data_qs += `&session_key=${session_key ? session_key : ""}`;
      session_data_qs += `&visitor_key=${visitor_key ? visitor_key : ""}`;
      session_data_qs += `&customer_key=${customer_key ? customer_key : ""}`;

      let requestUrl = `${collectionPath}object_id=${collectionId}${session_data_qs}`;
      let tagRequestUrl = tagName
        ? `${collectionTagPath}object_id=${collectionId}&second_id=${tagName}${session_data_qs}`
        : "";
      let response = await fetch(tagRequestUrl ? tagRequestUrl : requestUrl);

      if (response.status === 204) {
        // no content collection + tag, fallback to root collection
        response = await fetch(requestUrl);
      }

      if (response.ok && response.status === 200) {
        let data = await response.json();

        // limit data to 16 items
        if (data.length > 16) {
          data.length = 16;
        }

        if (data && data.length > 0) {
          const recsContainer = document.querySelector(".js-collection-recs");
          const recsList = document.createElement("ul");
          recsList.classList.add(
            "collection-recs__list",
            "list-unstyled",
            "splide__list"
          );
          recsList.role = "list";

          const priceFormatter = (price) => {
            const currentCurrency = window.Shopify.currency.active;

            if (currentCurrency === "USD" || currentCurrency === "GBP") {
              const shopifyLocale = `${window.Shopify.locale}-${window.Shopify.country}`;
              const formattedPrice = parseFloat(price).toLocaleString(
                shopifyLocale,
                { style: "currency", currency: currentCurrency }
              );
              return formattedPrice;
            }

            return null;
          };

          data.forEach((rec) => {
            const recItem = document.createElement("li");
            recItem.classList.add("collection-recs__item", "splide__slide");
            recItem.dataset.id = rec.id;
            const recLink = document.createElement("a");
            recLink.href = rec.url;
            recLink.title = rec.title;

            const recTitle = document.createElement("div");
            recTitle.classList.add("collection-recs__title");
            recTitle.textContent = rec.title;

            const recImg = document.createElement("img");
            recImg.src = rec.image_url_primary.replace(".jpg", "_x225.jpg");
            recImg.alt = rec.title;
            recImg.width = 155;
            recImg.height = 155;
            recImg.loading = "lazy";

            recLink.append(recImg);

            // format price, if ok then add to item
            const itemPrice = priceFormatter(rec.min_price);
            if (itemPrice) {
              const recPrice = document.createElement("div");
              recPrice.classList.add("collection-recs__price");
              recPrice.textContent = itemPrice;
              recLink.append(recPrice);
            }

            recItem.append(recLink);
            recsList.append(recItem);
          });

          // create splide nodes
          const splideContainer = document.createElement("div");
          splideContainer.classList.add("splide");
          const splideTrack = document.createElement("div");
          splideTrack.classList.add("splide__track");

          // append splide nodes
          splideTrack.append(recsList);
          splideContainer.append(splideTrack);
          recsContainer.appendChild(splideContainer);

          // create a subtitle and add before splide
          const recsSubtitle = document.createElement("h2");
          recsSubtitle.classList.add("collection-recs__subtitle");
          recsSubtitle.textContent = "Recommended for you";
          recsContainer.insertBefore(recsSubtitle, splideContainer);

          const mountRecs = () => {
            const splide = new Splide(".splide", {
              type: "loop",
              snap: true,
              speed: 1000,
              perPage: 8,
              drag: "free",
              gap: "1.6rem",
              breakpoints: {
                990: {
                  perPage: 6,
                  gap: "1rem",
                },
                800: {
                  perPage: 4,
                  gap: "1rem",
                },
                600: {
                  perPage: 3,
                  gap: "1.2rem",
                },
                440: {
                  perPage: 2,
                  gap: "1rem",
                },
              },
            });

            splide.mount();

            splide.on("click", function (e) {
              const productId = e.slide.dataset.id;
              const product = data.find((item) => item.id === productId);
              const recEventData = {
                product_id: product.id,
                object_id: collectionId,
                tag_filter: tagName,
              };
              window.sendRecommendationClickEventBeacon(recEventData);
            });
          };

          //50ms delay
          setTimeout(mountRecs, 0);
        }
      }
    }
  })();
}
